import * as React from 'react';
import { ICase } from '../../../../share/types/case/case';
import { CaseInfoLayout } from '../layouts/TransferInfo';
import { IAgency } from 'src/share/types/agency';
import { getAgenciesFromCase } from 'src/share/utils/getAgenciesFromCase';

export interface ICaseInfoFormState {
  clicked: { [key: string]: boolean };
};

export interface ICaseInfoFormProps {
  caseInfo: ICase;
  form: (name: string, required?: boolean) => any;
  submitted: boolean;
  disabled: boolean;
  agencies: any;
  targetAgency: string;
  transferCaseInformation: string;
};

export class CaseInfoForm extends React.Component<ICaseInfoFormProps, ICaseInfoFormState> {
  constructor(props: ICaseInfoFormProps) {
    super(props);
    this.state = {
      clicked: {}
    }
  }

  public getTargetAgencies() {
    const { agencies } = this.props;
    const sortedAgencies = agencies.sort((a, b) => (a.country > b.country) ? 1 : ((b.country > a.country) ? -1 : 0));
    const agenciesInCase = getAgenciesFromCase(this.props.caseInfo);
    return sortedAgencies.filter(agency => !agenciesInCase.find(agencyCode => agencyCode === agency.code));
  }

  public getAgenciesOptions() {
    const agencies = this.getTargetAgencies();
    return agencies.map((agency) => <option key={agency.code} value={agency.code}>{`${agency.country} - ${agency.name}`}</option>);
  }

  public getCurrentAgency(agencies: IAgency[], currentAgency: string) {
    const agencyInfo = agencies.find(agency => agency.code === currentAgency);
    return agencyInfo ? agencyInfo.name : 'Agency not found';
  }

  public render() {
    return <CaseInfoLayout that={this} />;
  }
}

export default ICaseInfoFormProps;



// WEBPACK FOOTER //
// ./src/modules/Case/TransferCase/components/TransferForm.tsx